import { compose } from 'redux';
import { withFeatureToggles } from 'modules/shell/hoc/withFeatureToggles';
import { withStyles } from '@material-ui/core/styles';
import { MAO_INVENTORY, RETURN_DATE } from 'constants/featureToggleNames';
import ProductDetails from './ProductDetails';
import styles from './ProductDetails.styles';

export default compose(
  withFeatureToggles({
    isReturnDateEnabled: RETURN_DATE,
    isMAOInventoryEnabled: MAO_INVENTORY,
  }),
  withStyles(styles),
)(ProductDetails);
